import * as React from "react"

export const DRIFT_TONE = {
  PENDING: "pending",
  SUCCESS: "success",
  ERROR: "error",
  FALLBACK: "fallback",
}

const INITIAL_STATE = {
  visible: false,
  message: "",
  tone: DRIFT_TONE.PENDING,
}

const DriftStatusChip = () => {
  const [status, setStatus] = React.useState(INITIAL_STATE)

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return undefined
    }

    const handleStatusUpdate = event => {
      const detail = event.detail || {}

      if (detail.visible === false) {
        setStatus(INITIAL_STATE)
        return
      }

      setStatus({
        visible: true,
        message: detail.message || "",
        tone: detail.tone || DRIFT_TONE.PENDING,
      })
    }

    window.addEventListener("wm:drift-status", handleStatusUpdate)

    return () => {
      window.removeEventListener("wm:drift-status", handleStatusUpdate)
    }
  }, [])

  return (
    <div
      className={`drift-status-chip ${status.visible ? "is-visible" : ""} ${
        status.tone ? `tone-${status.tone}` : ""
      }`.trim()}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className="drift-status-chip__indicator" aria-hidden="true" />
      <span className="drift-status-chip__message">{status.message}</span>
    </div>
  )
}

export default DriftStatusChip
